import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchGalleryPhotos = async ({ patientId, photoType, photoArea, selectedUser, trialArea }) => {
  const token = localStorage.getItem("token");

  const response = await axios.get(`${__API_URL__}/api/patient/patient/photo_session_gallery/`, {
    params: {
      PatientId: patientId,
      photo_type: photoType || "",
      photo_area: photoArea || "",
      selected_user: selectedUser || "",
      trial_area: trialArea ?? "",
      trialCroFilter: trialArea ?? "",
    },
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  return response.data.data;
};

const useGetGalleryPhotos = ({
  patientId,
  photoType,
  photoArea,
  selectedUser,
  trialArea,
  enabled = true,
}) => {
  return useQuery({
    queryKey: ["gallery_photos", patientId, photoType, photoArea, selectedUser, trialArea],
    queryFn: () => fetchGalleryPhotos({ patientId, photoType, photoArea, selectedUser, trialArea }),
    enabled: enabled && Boolean(patientId),
  });
};

export default useGetGalleryPhotos;
